import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../Services/auth.service';
import { CommonService } from '../Services/common.service';
import { Location } from '@angular/common';
import { Subject } from 'rxjs';
import { InsuranceService } from '../Services/insurance.service';
import { AccountService } from '../Services/account.service';
import { CookieService } from '../Services/cookie';


@Component({
  selector: 'app-insurancr-nick',
  templateUrl: './insurancr-nick.component.html',
  standalone:false,
  styleUrls: ['./insurancr-nick.component.scss']
})
export class InsurancrNickComponent implements OnInit {
  modalObservable: Subject<void> = new Subject<void>();
  internalId: string = "";
  InspolicyName: string = ""

  constructor(private auth: AuthService, private account: AccountService, private location: Location, private commonP: CommonService, private _router: Router, private Insu: InsuranceService,
    private cookieService: CookieService,) { }

  async ngOnInit(): Promise<any> {
    this.commonP.presentLoading();
    this.auth.accessToken = await this.commonP.Get("token");
    this.auth.VerifyToken({}, this.auth.accessToken).then(async (data: any) => {
      if (data?.response?.code == 1) {
    }
    else {
      await this.commonP.hideLoading();
      this.commonP.ParseErrorAlert("", "", this._router, data);
    }
  
    })
  
    let a =await this.cookieService.get("InsuranceinternalId", true);
    let n =await this.cookieService.get("Insurancenick", true);


    if (a) {

      this.internalId = a;

    }
    if (n) {

      this.InspolicyName = n;

    }
    this.commonP.hideLoading();
    }




  updateNickName(name) {
    let body = {
      InternalId: this.internalId,
      NickName: name ? '' : this.InspolicyName
    }
    this.commonP.presentLoading();
    this.Insu.UpdateNickName(body.InternalId, body.NickName, this.auth.accessToken).then((data: any) => {
      if (data?.response?.code == 1) {

        this.account.GetLoanDashboard(this.auth.accessToken).then((data: any) => {
          if (data?.response?.code == 1) {

            this.commonP.hideLoading();

            if (name == 'remove') {

              this.commonP.showSuccessToast('You have succesfully removed the nickname of your selected Insurance Policy', 'Insurance Policy Removed');



            } else if (this.InspolicyName) {
              this.commonP.showSuccessToast('You have succesfully added the nickname of your selected Insurance Policy', 'Insurance Policy Added');

            }
            this._router.navigateByUrl('/Insurance');

          } else {
            this.commonP.hideLoading();
            this.commonP.ParseErrorAlert('', '', this._router, data);
          }
        })


      } else {

        this.commonP.hideLoading();
        this.commonP.ParseErrorAlert('', '', this._router, data);
      }



    })

  }


  isValid() {
    if (this.InspolicyName != null && this.InspolicyName != "") {
      return false
    } else {
      return true
    }
  }
  back() {
    this.location.back()
  }

  showModal(num) {
    this.modalObservable.next(num);
  }
}
